const React = require('react')
const PropTypes = require('prop-types')
const withStyles = require('withStyles').default
const styles = require('./app.less')
const config = require('lib/config')
const radio = require('lib/radio')
const isLoggedIn = require('module/viewer/helpers/is_logged_in')
const log = require('log').create('app') // eslint-disable-line

// App component manages viewer state. It receives the viewer from the parent
// context, and assumes it as a state object, exposing it as child context for
// children

const viewer_change_events = [
    'change:first_name',
    'change:last_name',
    'change:bio',
    'change:spotlight',
    'change:spotlight_trial',
    'change:images[*]',
    'change:layout',
    'add:locations',
    'remove:locations',
    'add:interests',
    'remove:interests',
    'add:roles',
    'remove:roles',
    'reset:jobs',
    'add:schools',
    'remove:schools',
    'reset:schools',
    'change:contact_me',
    'change:apps[*]',
    'remove:apps',
    'add:portfolio',
    'remove:portfolio',
    'change:portfolio[*]',
    'reset:portfolio',
    'change:video',
    'change:testimonials.header',
    'change:testimonials.items[*]',
    'add:testimonials.items',
    'remove:testimonials.items',
    'add:mapped_domains',
    'remove:mapped_domains',
    'reset:mapped_domains',
    'change:actions',
].join(' ')

class App extends React.Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            viewer: context.viewer,
        }
        this.onViewerChange = this.onViewerChange.bind(this)
    }

    getChildContext() {
        return {
            viewer: this.state.viewer,
        }
    }

    componentDidMount() {
        this.listenForMetricClicks()
        this.sendMetrics()
        this.checkForServerMessage()
        this.checkForSiteStatus()
        this.listenToViewer()
    }
    componentWillUnmount() {
        this.stopListening()
    }

    onViewerChange(model, attrs, options = {}) {
        if (options.silent) return
        this.updateViewerState()
    }

    updateViewerState() {
        const viewer = this.viewer.model.toJSON()

        this.setState({
            viewer,
        })
    }

    listenForMetricClicks() {
        const $ = require('lib/jquery')
        const triggered = {}
        $.body.on('click', '[data-metric-event]', (e) => {
            const $target = $(e.currentTarget)
            // data-metric-channel is optional, defaults to radio.metrics
            const channel_name = $target.data('metric-channel') || 'metrics'
            const channel = radio[channel_name]
            const event = $target.data('metric-event')
            if (channel && event) {
                triggered[channel] = triggered[channel] || {}
                if (triggered[channel][event]) return
                triggered[channel][event] = true
                channel.trigger(event)
            }
        })
    }

    listenToViewer() {
        this.viewer = require('module/viewer/viewer')
        // this.viewer.model.on('all', log)
        this.viewer.model.on(viewer_change_events, this.onViewerChange)
    }

    sendMetrics() {
        const { id } = this.context.page
        const { viewer } = this.context

        radio.app.trigger('start', {
            page_name: id,
            viewer: {
                logged_in: isLoggedIn(viewer),
                user_name: viewer.user_name,
            },
        })
    }

    checkForServerMessage() {
        // check for globals.SERVER_MESSAGE
        const { SERVER_MESSAGE } = this.context.globals
        if (SERVER_MESSAGE) {
            require.ensure([], () => {
                const ServerMessage = require('module/server_message/server_message')
                ServerMessage.show(SERVER_MESSAGE)
            }, 'server-message')
        }
    }

    checkForSiteStatus() {
        const site_status = config.get('site.status')
        if (site_status) {
            require.ensure([], () => {
                const SiteStatus = require('module/site_status/site_status')
                SiteStatus.show(site_status, this.context)
            }, 'site-status')
        }
    }

    stopListening() {
        this.viewer.model.off(viewer_change_events, this.onViewerChange)
    }

    render() {
        return this.props.children
    }

}

App.propTypes = {
    children: PropTypes.element,
    route: PropTypes.shape({
        childRoutes: PropTypes.array,
    }).isRequired,
}

App.contextTypes = {
    globals: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
    page: PropTypes.object.isRequired,
}

App.childContextTypes = {
    viewer: PropTypes.object,
}

module.exports = withStyles(styles)(App)
